export default __webpack_public_path__ + "static/media/36I-114288_-21007_0.17acd8a5.jpg";